import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import { customPalette } from '../themes/customTheme';

export const CustomTable = ({ tableKey, title, subtitles, values }) => {
  return (
    <TableContainer
      component={Paper}
      key={tableKey}
      sx={{
        width: '100%',
        borderRadius: '0',
        paddingLeft: '64px',
        paddingBottom: '6px',
        backgroundColor: `${customPalette.background.default}`,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: '16px',
          fontWeight: '600',
          lineHeight: '23px',
          marginBottom: '10px',
          marginTop: '16px',
        }}
      >
        {title}
      </Typography>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {subtitles.map((subtitle, subtitleIndex) => (
              <TableCell
                key={subtitleIndex}
                sx={{
                  fontSize: '16px',
                  fontWeight: '600',
                  lineHeight: '23px',
                  color: `${customPalette.greyDark}`,
                }}
              >
                {subtitle}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow
            sx={{
              '&:last-child td, &:last-child th': {
                border: 0,
              },
            }}
          >
            {values.map((value, valueIndex) => (
              <TableCell
                key={valueIndex}
                sx={{
                  fontSize: '16px',
                  fontWeight: '400',
                  lineHeight: '21px',
                  color: `${customPalette.greyDark}`,
                }}
              >
                {value}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
